module.exports = __webpack_public_path__ + "static/media/Agustina.21f233e1.woff";